export default "__VITE_ASSET__CY5hbmh2__"